/* ============================================================
   JV Runsheet Planner -- Shopify Bridge Mode
   Full transplant from GAS RunsheetPlannerApp.html
   google.script.run calls replaced with jvBridge.callAdmin()
   ============================================================ */

/* ============================================================
   GOOGLE.SCRIPT.RUN CALL SITE MAP (preserved from RunsheetPlannerApp.html)
   1. appGetBrides()                        -- load bride list
   2. appGetWorkspace(brideName, overrides)  -- hydrate workspace
   3. appPublishRunsheet(payload)            -- publish runsheet
   4. appRepairRunsheetSources(brideName)    -- repair source data
   ============================================================ */

var hasBridge = (typeof window.jvBridge !== 'undefined' && typeof window.jvBridge.callAdmin === 'function');

/* -- Touch Device Detection ------------------------------------------ */
function isTouchDevice_() {
  try {
    return !!(
      (typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches) ||
      ("ontouchstart" in window) ||
      (navigator.maxTouchPoints > 0)
    );
  } catch (e) { return false; }
}
var IS_TOUCH_DEVICE = isTouchDevice_();

/* -- State ----------------------------------------------------------- */
var state = {
  brides: [],
  currentBride: "",
  currentStage: "booking",
  workspace: null,
  leadArtist: "",
  activeTeam: [],
  sourceServicesDraft: [],
  requestToken: 0,
  dragServiceId: "",
  dragSource: "",
  lastHydrateDebug: null,
  timelineDirty: false,
  debugExpanded: false,
  sidebarOpen: false,
  fabOpen: false
};

/* -- Touch Drag State ------------------------------------------------ */
var touchDrag = {
  active: false,
  element: null,
  ghost: null,
  serviceId: "",
  source: "",
  startX: 0,
  startY: 0,
  holdTimer: null,
  currentDropTarget: null
};

var STAGES = [
  {
    id: "booking",
    count: "01",
    name: "Booking Details",
    note: "Review prefilled booking info and confirm the details the planner will rely on."
  },
  {
    id: "team",
    count: "02",
    name: "Team + Service Order",
    note: "Set the lead, choose the working artists, and tidy the service list before scheduling."
  },
  {
    id: "timeline",
    count: "03",
    name: "Timeline Preview",
    note: "Drag services between artists and refine the shape of the morning before publishing."
  }
];

/* -- Sidebar / Drawer ------------------------------------------------ */
function toggleSidebar() {
  state.sidebarOpen ? closeSidebar() : openSidebar();
}

function openSidebar() {
  state.sidebarOpen = true;
  document.getElementById("sidebar").classList.add("open");
  document.getElementById("sidebarOverlay").classList.add("visible");
}

function closeSidebar() {
  state.sidebarOpen = false;
  document.getElementById("sidebar").classList.remove("open");
  document.getElementById("sidebarOverlay").classList.remove("visible");
}

/* -- FAB Menu -------------------------------------------------------- */
function toggleFabMenu() {
  state.fabOpen ? closeFabMenu() : openFabMenu();
}

function openFabMenu() {
  state.fabOpen = true;
  document.getElementById("fabMenu").classList.add("open");
  document.getElementById("fabMain").innerHTML = '<i class="fa-solid fa-xmark"></i>';
}

function closeFabMenu() {
  state.fabOpen = false;
  document.getElementById("fabMenu").classList.remove("open");
  document.getElementById("fabMain").innerHTML = '<i class="fa-solid fa-ellipsis-vertical"></i>';
}

/* -- Button helpers (dual desktop + FAB buttons) --------------------- */
function setActionButtonsDisabled(disabled) {
  var ids = ["repairBtn", "repairBtnDesktop", "publishBtn", "publishBtnDesktop"];
  ids.forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.disabled = disabled;
  });
}

function setPublishDisabled(disabled) {
  ["publishBtn", "publishBtnDesktop"].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.disabled = disabled;
  });
}

function setRepairDisabled(disabled) {
  ["repairBtn", "repairBtnDesktop"].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.disabled = disabled;
  });
}

function setPublishContent(html) {
  ["publishBtn", "publishBtnDesktop"].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.innerHTML = html;
  });
}

function setRepairContent(html) {
  ["repairBtn", "repairBtnDesktop"].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.innerHTML = html;
  });
}

window.onload = function() {
  document.getElementById("search").addEventListener("input", renderBrides);
  renderStageBar();
  loadBrides();

  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
      closeSidebar();
      closeFabMenu();
    }
  });
};

/* -- CDN island fast-path (Win 1, 2026-07-17) -----------------------
   Reads the same shop-level bride-list island the runsheet builder paints
   from (shop.metafields.custom.runsheet_brides_cache_json, writer
   RunsheetBridesCache.gs). Shape: { data: [{name,dateStr,dateMs,isoDate}] }.
   Lets the bride list paint instantly (zero GAS); the live getBrides call
   below still fires to catch brand-new brides not yet on the CDN.
   Kill flag: window.JV_RSP_FASTPATH === false disables it. */
function rspBridesFromShopIsland_() {
  if (window.JV_RSP_FASTPATH === false) return null;
  try {
    var el = document.getElementById('jv-rsp-brides-cache');
    if (!el) return null;
    var raw = (el.textContent || el.innerText || '').trim();
    if (!raw || raw === 'null') return null;
    var parsed = JSON.parse(raw);
    var arr = parsed && Array.isArray(parsed.data) ? parsed.data : null;
    return (arr && arr.length) ? arr : null;
  } catch (_) { return null; }
}

/* -- BRIDGE CALL #1: appGetBrides() ---------------------------------- */
function loadBrides() {
  // Fast path: render the whole bride list from the CDN island (zero GAS),
  // then background-refresh live below. The live call stays as the fallback
  // when the island is null (cold/unwarmed).
  var islandBrides = rspBridesFromShopIsland_();
  if (islandBrides) {
    state.brides = islandBrides;
    renderBrides();
  }

  jvBridge.callAdmin('bridge_runsheet_getBrides', {})
    .then(function(res) {
      if (res.ok) {
        state.brides = Array.isArray(res.data) ? res.data : [];
        renderBrides();
      } else if (!islandBrides) {
        document.getElementById("brideList").innerHTML =
          '<div class="empty-state"><i class="fa-solid fa-triangle-exclamation"></i><div>' +
          escapeHtml(res.error || "Failed to load brides") +
          "</div></div>";
      }
    })
    .catch(function(err) {
      // Keep the island-painted list on a background-refresh failure.
      if (islandBrides) return;
      document.getElementById("brideList").innerHTML =
        '<div class="empty-state"><i class="fa-solid fa-triangle-exclamation"></i><div>' +
        escapeHtml(getErrorMessage(err)) +
        "</div></div>";
    });
}

function renderBrides() {
  var q = String(document.getElementById("search").value || "").toLowerCase().replace(/[''‚‛′‵`]/g, "'");
  var list = document.getElementById("brideList");
  var filtered = state.brides.filter(function(bride) {
    return String(bride.name || "").toLowerCase().includes(q);
  });

  if (!filtered.length) {
    list.innerHTML = '<div class="empty-state"><i class="fa-solid fa-magnifying-glass"></i><div>No matching booked brides found.</div></div>';
    return;
  }

  list.innerHTML = "";
  filtered.forEach(function(bride) {
    var div = document.createElement("div");
    div.className = "bride-item" + (state.currentBride === bride.name ? " active" : "");
    div.innerHTML =
      '<div class="bride-name">' + escapeHtml(bride.name) + '</div>' +
      '<div class="muted-text">' + escapeHtml(bride.dateStr || "") + "</div>";
    div.onclick = function() {
      loadWorkspace(bride.name);
    };
    list.appendChild(div);
  });
}

function renderStageBar() {
  var bar = document.getElementById("stageBar");
  bar.innerHTML = STAGES.map(function(stage) {
    return (
      '<button class="stage-pill' + (state.currentStage === stage.id ? ' active' : '') + '" onclick="setStage(\'' + stage.id + '\')">' +
        '<div class="stage-count">' + escapeHtml(stage.count) + "</div>" +
        '<div class="stage-name">' + escapeHtml(stage.name) + "</div>" +
        '<div class="stage-note">' + escapeHtml(stage.note) + "</div>" +
      "</button>"
    );
  }).join("");
}

function setStage(stageId) {
  state.currentStage = stageId;
  renderStageBar();
  renderStage();
}

/* -- BRIDGE CALL #2: appGetWorkspace(brideName, overrides) ----------- */
function loadWorkspace(brideName, overrides) {
  state.currentBride = brideName;
  renderBrides();
  closeSidebar();
  showBanner("Loading runsheet workspace...", "success");
  setActionButtonsDisabled(true);
  showLoading();

  var token = ++state.requestToken;

  jvBridge.callAdmin('bridge_runsheet_getWorkspace', { brideName: brideName, overrides: overrides || {} })
    .then(function(res) {
      if (token !== state.requestToken) return;
      if (res.ok) {
        hydrateWorkspace(res.data || {});
      } else {
        handleWorkspaceError(res.error || "Failed to load workspace");
      }
    })
    .catch(function(err) {
      if (token !== state.requestToken) return;
      handleWorkspaceError(err);
    });
}

function hydrateWorkspace(workspace) {
  state.workspace = workspace || {};
  state.timelineDirty = false;
  state.lastHydrateDebug = buildHydrateDebug_(workspace);
  state.leadArtist = String(workspace.leadArtist || "").trim();
  state.activeTeam = uniqueNames(
    (workspace.selectedArtists && workspace.selectedArtists.length
      ? workspace.selectedArtists
      : workspace.suggestedArtists) || []
  );

  if (state.leadArtist && state.activeTeam.indexOf(state.leadArtist) === -1) {
    state.activeTeam.unshift(state.leadArtist);
  }
  if (!state.leadArtist && state.activeTeam.length) {
    state.leadArtist = state.activeTeam[0];
  }

  state.sourceServicesDraft = normaliseEditableServices(
    (workspace.sourceServices && workspace.sourceServices.length
      ? workspace.sourceServices
      : workspace.services) || []
  );
  sanitizeSourceServicesDraftAssignments_();

  setRepairDisabled(false);
  setPublishDisabled(!(workspace.services && workspace.services.length));
  document.getElementById("bTitle").innerText = workspace.brideName || state.currentBride || "Runsheet Planner";
  document.getElementById("bMeta").innerText = buildMetaLine(workspace);

  renderHeroStrip();
  renderDebugPanel();
  renderStatus();
  renderStage();
}

function handleWorkspaceError(err) {
  state.workspace = null;
  state.debugExpanded = true;
  state.lastHydrateDebug = {
    state: "error",
    brideName: state.currentBride,
    message: getErrorMessage(err)
  };
  setActionButtonsDisabled(true);
  showBanner(getErrorMessage(err), "error");
  document.getElementById("heroStrip").innerHTML = "";
  renderDebugPanel();
  document.getElementById("stageContent").innerHTML =
    '<div class="empty-state"><i class="fa-solid fa-triangle-exclamation"></i><div>Unable to build the runsheet workspace.</div></div>';
}

function showLoading() {
  document.getElementById("heroStrip").innerHTML = "";
  state.lastHydrateDebug = {
    state: "loading",
    brideName: state.currentBride,
    message: "Waiting for browser payload"
  };
  renderDebugPanel();
  document.getElementById("stageContent").innerHTML =
    '<div class="loader"><div class="spinner"></div><div>Building the latest runsheet workspace...</div></div>';
}

function renderHeroStrip() {
  var w = state.workspace;
  if (!w) {
    document.getElementById("heroStrip").innerHTML = "";
    return;
  }

  var warningCount = Array.isArray(w.warnings) ? w.warnings.length : 0;
  var serviceCount = state.sourceServicesDraft.length;

  document.getElementById("heroStrip").innerHTML =
    '<div class="compact-banner-main">' +
      '<h3>' + escapeHtml(w.brideName || state.currentBride || "") + '</h3>' +
      '<p>' + escapeHtml(w.weddingDate || "") + ' -- ' + escapeHtml(w.location || "Location TBC") +
      ' -- ' + escapeHtml(renderReadinessHeadline(w)) + '</p>' +
    '</div>' +
    '<div class="compact-banner-stats">' +
      renderMiniStat("Ready By", w.readyBy || "Confirm") +
      renderMiniStat("Services", String(serviceCount)) +
      renderMiniStat("Artists", String(w.recommendedArtistCount || 1)) +
      renderMiniStat("Warnings", String(warningCount)) +
    '</div>';
}

function renderHeroStat(label, value) {
  return (
    '<div class="hero-stat">' +
      "<span>" + escapeHtml(label) + "</span>" +
      "<strong>" + escapeHtml(value) + "</strong>" +
    "</div>"
  );
}

function renderStatus() {
  var w = state.workspace;
  if (!w) {
    hideBanner();
    return;
  }

  var warnings = Array.isArray(w.warnings) ? w.warnings : [];
  if (warnings.length) {
    var severity = warnings.some(function(item) {
      return String((item && item.severity) || "").toLowerCase() === "error";
    }) ? "error" : "warning";
    var extra = warnings.length > 1 ? " +" + (warnings.length - 1) + " more" : "";
    showBanner(warnings[0].message + extra, severity);
    return;
  }

  if (w.services && w.services.length) {
    showBanner("Preview ready. Drag services around, then publish when the schedule looks right.", "success");
    return;
  }

  showBanner("The builder has prefilled the booking and service list. Confirm the ready-by time to generate the timed timeline.", "warning");
}

function renderDebugPanel() {
  var panel = document.getElementById("debugPanel");
  var debug = state.lastHydrateDebug;
  if (!panel || !debug) {
    if (panel) panel.style.display = "none";
    return;
  }

  panel.style.display = "block";
  panel.className = "debug-panel" + (state.debugExpanded ? "" : " collapsed");
  panel.innerHTML =
    '<div class="debug-head">' +
      "<h4>Browser Debug</h4>" +
      '<button class="debug-toggle" onclick="toggleDebugPanel()">' + (state.debugExpanded ? "Hide" : "Show") + "</button>" +
    "</div>" +
    '<div class="debug-body">' +
      '<div class="debug-grid">' +
        renderDebugItem_("State", debug.state || "") +
        renderDebugItem_("Bride", debug.brideName || "") +
        renderDebugItem_("Date", debug.weddingDate || "") +
        renderDebugItem_("Location", debug.location || "") +
        renderDebugItem_("Ready By", debug.readyBy || "") +
        renderDebugItem_("Source Services", String(debug.sourceServices || 0)) +
        renderDebugItem_("Timed Services", String(debug.timedServices || 0)) +
        renderDebugItem_("Recommended Artists", String(debug.recommendedArtistCount || 0)) +
        renderDebugItem_("Selected Artists", debug.selectedArtists || "") +
        renderDebugItem_("Lead Artist", debug.leadArtist || "") +
        renderDebugItem_("Phone", debug.phone || "") +
        renderDebugItem_("Message", debug.message || "OK") +
      "</div>" +
    "</div>";
}

function toggleDebugPanel() {
  state.debugExpanded = !state.debugExpanded;
  renderDebugPanel();
}

function renderStage() {
  if (!state.workspace) {
    document.getElementById("stageContent").innerHTML =
      '<div class="empty-state"><i class="fa-solid fa-arrow-left"></i><div>Select a bride to start the staged runsheet builder.</div></div>';
    return;
  }

  if (state.currentStage === "booking") {
    renderBookingStage();
  } else if (state.currentStage === "team") {
    renderTeamStage();
  } else {
    renderTimelineStage();
  }
}

function renderBookingStage() {
  var w = state.workspace;
  var content = document.getElementById("stageContent");
  var readyByValue = displayTimeToInput(w.readyBy);

  content.innerHTML =
    '<div class="stage-grid">' +
      '<section class="stage-card">' +
        '<div class="card-head">' +
          '<div><h3>Booking Details</h3><p>This page should feel like the top of the finished runsheet. Keep it simple and editable.</p></div>' +
          '<button class="btn btn-soft" onclick="applyBookingDetails()"><i class="fa-solid fa-rotate-right"></i> Save + Refresh</button>' +
        '</div>' +
        '<div class="pdf-header-grid">' +
          renderPdfWideField("Bride", '<input type="text" readonly value="' + escapeHtml(w.brideName || state.currentBride || "") + '">') +
          renderPdfField("Date", '<input type="text" readonly value="' + escapeHtml(w.weddingDate || "") + '">') +
          renderPdfField("Bride Phone", '<input type="text" readonly value="' + escapeHtml(w.phone || "") + '">') +
          renderPdfWideField("Address", '<input id="bookingLocation" type="text" value="' + escapeHtml(w.location || "") + '">') +
          renderPdfField("Arrival Time", '<input type="text" readonly value="' + escapeHtml(w.draftStartTime || "TBC") + '">') +
          renderPdfField("Departure / Ready By", '<input id="bookingReadyBy" type="time" value="' + escapeHtml(readyByValue) + '">') +
          renderPdfField("Lead Artist", '<input type="text" readonly value="' + escapeHtml(state.leadArtist || w.leadArtist || "TBC") + '">') +
          renderPdfField("Working Team", '<input type="text" readonly value="' + escapeHtml((state.activeTeam || []).join(", ") || "TBC") + '">') +
        "</div>" +
        '<div class="form-grid" style="margin-top:18px;">' +
          renderEditableTextarea("Services Requested", "bookingServicesRequested", w.servicesRequested || "", "Short headline only. The service units are shown separately.") +
          renderEditableTextarea("Notes / Bridal Party", "bookingBridalPartyCount", w.bridalPartyCount || "", "Use this for short booking notes, not for counting units.") +
        '</div>' +
        '<div class="stage-actions">' +
          '<button class="btn btn-ghost" onclick="setStage(\'team\')"><i class="fa-solid fa-arrow-right"></i> Next: Team Builder</button>' +
        "</div>" +
      "</section>" +
      '<aside class="stack">' +
        renderPartyUnitsPanel() +
        renderServiceHeadlinePanel() +
        renderConfirmationPanel() +
      "</aside>" +
    "</div>";
}

function renderTeamStage() {
  var w = state.workspace;
  var content = document.getElementById("stageContent");
  var teamOptions = Array.isArray(w.team) ? w.team : [];

  content.innerHTML =
    '<div class="service-builder-grid">' +
      '<section class="stage-card">' +
        '<div class="card-head">' +
          '<div><h3>Service Builder</h3><p>Drag the service list into the right order, then edit names, service types, and artist assignments where needed.</p></div>' +
          '<div class="chip-row"><span class="chip">' + escapeHtml(String(state.sourceServicesDraft.length)) + ' source rows</span></div>' +
        '</div>' +
        '<div class="lead-callout">' +
          '<div><strong>Lead Artist</strong><span>Choose the lead here first. Bride services and the final runsheet header will use this selection.</span></div>' +
          '<div style="min-width:220px;">' + renderLeadArtistSelect(teamOptions) + '</div>' +
        '</div>' +
        '<div class="service-stack">' + renderEditableServiceCards() + "</div>" +
      "</section>" +
      '<aside class="stack">' +
        '<div class="stage-card">' +
          '<div class="card-head">' +
            '<div><h3>Team Builder</h3><p>Choose the lead and lock in the working artists for this draft.</p></div>' +
            '<button class="btn btn-soft" onclick="applyTeamAndServices()"><i class="fa-solid fa-wand-magic-sparkles"></i> Refresh Timeline</button>' +
          '</div>' +
          '<div class="team-grid">' + renderTeamCards(teamOptions) + "</div>" +
          '<div class="stage-actions">' +
            '<button class="btn btn-soft" onclick="setStage(\'booking\')"><i class="fa-solid fa-arrow-left"></i> Back</button>' +
            '<button class="btn btn-ghost" onclick="setStage(\'timeline\')"><i class="fa-solid fa-arrow-right"></i> Next: Timeline</button>' +
          "</div>" +
        "</div>" +
        renderTeamSummaryPanel() +
        renderConfirmationPanel() +
      "</aside>" +
    "</div>" +
    '';

  bindStageInputs();
}

function renderTimelineStage() {
  var w = state.workspace;
  var content = document.getElementById("stageContent");
  var services = Array.isArray(w.services) ? w.services : [];

  if (!services.length) {
    content.innerHTML =
      '<div class="stage-grid">' +
        '<section class="stage-card">' +
          '<div class="card-head"><div><h3>Timeline Preview</h3><p>The timeline will appear here once the planner can generate timed service rows.</p></div></div>' +
          '<div class="empty-state">' +
            '<i class="fa-solid fa-clock"></i>' +
            '<div><strong>Finish time still needed.</strong><br>Set the ready-by time in Booking Details, then refresh the preview to build the schedule.</div>' +
          "</div>" +
          '<div class="stage-actions">' +
            '<button class="btn btn-soft" onclick="setStage(\'booking\')"><i class="fa-solid fa-arrow-left"></i> Back to Booking</button>' +
          "</div>" +
        "</section>" +
        '<aside class="stack">' + renderConfirmationPanel() + "</aside>" +
      "</div>";
    return;
  }

  content.innerHTML =
    '<div class="stage-grid">' +
      '<section class="stage-card">' +
        '<div class="card-head">' +
          '<div><h3>Drag + Drop Timeline</h3><p>Use the artist columns like the real runsheet sheet. Move services between columns, then rebuild when you want the timing recalculated.</p></div>' +
          '<button class="btn btn-soft" onclick="applyTeamAndServices()"><i class="fa-solid fa-rotate-right"></i> ' + (state.timelineDirty ? 'Rebuild Preview' : 'Refresh Preview') + '</button>' +
        '</div>' +
        (state.timelineDirty
          ? '<div class="panel" style="margin-bottom:16px; background:#fff6eb; border-color:#f1dcc2;"><strong>Local drag changes saved.</strong><div class="panel-sub" style="margin-top:6px;">The artist columns have been updated instantly. Click <strong>Rebuild Preview</strong> when you want staggered times, setup, and pack-up recalculated.</div></div>'
          : '') +
        '<div class="timeline-grid">' + renderTimelineLanes() + "</div>" +
        '<div class="stage-actions">' +
          '<button class="btn btn-soft" onclick="setStage(\'team\')"><i class="fa-solid fa-arrow-left"></i> Back to Team</button>' +
          '<button class="btn btn-primary" onclick="publish()"><i class="fa-solid fa-paper-plane"></i> Publish Runsheet</button>' +
        "</div>" +
      "</section>" +
      '<aside class="stack">' +
        renderTimelineSummaryPanel() +
        renderConfirmationPanel() +
      "</aside>" +
    "</div>";
}

function renderPartyUnitsPanel() {
  var summary = buildPartyUnitSummary();
  return (
    '<div class="panel">' +
      "<h4>Bridal Party Units</h4>" +
      '<div class="panel-sub">This should be countable at a glance, not buried in a sentence.</div>' +
      '<div class="party-unit-grid">' +
        renderPartyUnit("Bride", String(summary.bride)) +
        renderPartyUnit("Bridesmaid", String(summary.bridesmaid)) +
        renderPartyUnit("Mother", String(summary.mother)) +
        renderPartyUnit("Guest", String(summary.guest)) +
      "</div>" +
    "</div>"
  );
}

function renderServiceHeadlinePanel() {
  var bundles = buildPersonBundleSummary();
  var list = bundles.length
    ? bundles.map(function(item) {
        return '<div>' + escapeHtml(item.person) + ' -- ' + escapeHtml(item.bundle) + "</div>";
      }).join("")
    : '<div>No source services found yet.</div>';

  return (
    '<div class="panel">' +
      "<h4>Prefilled Services</h4>" +
      '<div class="panel-sub">Only the useful bits. Source details stay hidden unless they matter.</div>' +
      '<div class="chip-row" style="margin-bottom:12px;">' + renderServicesSourceChips() + "</div>" +
      '<div class="quiet-list">' + list + "</div>" +
    "</div>"
  );
}

function renderConfirmationPanel() {
  var warnings = Array.isArray(state.workspace.warnings) ? state.workspace.warnings : [];
  var confidence = (state.workspace && state.workspace.confidence) || {};
  var items = Array.isArray(confidence.items) ? confidence.items.filter(function(item) {
    var status = String((item && item.status) || "").toLowerCase();
    return status === "low" || status === "missing";
  }) : [];

  var rows = [];
  warnings.forEach(function(item) {
    rows.push(renderWarningRow(item.code || "Warning", item.message || ""));
  });

  items.forEach(function(item) {
    rows.push(renderWarningRow(item.label || "Confirm", (item.detail || item.sourceLabel || "Needs review")));
  });

  if (!rows.length) {
    rows.push(renderWarningRow("Status", "No major confirmation blockers surfaced right now."));
  }

  return (
    '<div class="panel">' +
      "<h4>Still needs confirmation</h4>" +
      '<div class="panel-sub">This is the short list of things most likely to hold up a clean runsheet.</div>' +
      '<div class="warning-list">' + rows.join("") + "</div>" +
    "</div>"
  );
}

function renderTeamSummaryPanel() {
  var w = state.workspace;
  return (
    '<div class="panel">' +
      "<h4>Team Snapshot</h4>" +
      '<div class="panel-sub">Short and useful: who is leading, how many are selected, and how many the planner wants.</div>' +
      '<div class="readonly-pair">' +
        renderMiniStat("Lead", state.leadArtist || "TBC") +
        renderMiniStat("Selected", String(state.activeTeam.length || 0)) +
        renderMiniStat("Recommended", String(w.recommendedArtistCount || 1)) +
        renderMiniStat("Service Rows", String(state.sourceServicesDraft.length)) +
      "</div>" +
      '<div class="info-list" style="margin-top:14px;">' +
        renderInfoRow("Selected", escapeHtml((state.activeTeam || []).join(", ") || "No team selected")) +
        renderInfoRow("Suggested", escapeHtml((w.suggestedArtists || []).join(", ") || "No suggestion list")) +
      "</div>" +
    "</div>"
  );
}

function renderTimelineSummaryPanel() {
  var w = state.workspace;
  var latestFinish = findLatestFinish(w.services || []);
  return (
    '<div class="panel">' +
      "<h4>Timeline Snapshot</h4>" +
      '<div class="panel-sub">Useful checks before you publish the draft.</div>' +
      '<div class="readonly-pair">' +
        renderMiniStat("Starts", w.draftStartTime || findEarliestStart(w.services || []) || "TBC") +
        renderMiniStat("Finishes", latestFinish || w.readyBy || "TBC") +
        renderMiniStat("Timed Rows", String((w.services || []).length)) +
        renderMiniStat("Total Minutes", String(w.totalServiceMinutes || 0)) +
      "</div>" +
      '<div class="info-list" style="margin-top:14px;">' +
        renderInfoRow("Lead", w.leadArtist || "TBC") +
        renderInfoRow("Artists", (state.activeTeam || []).join(", ") || "No team selected") +
        renderInfoRow("Ready By", w.readyBy || "TBC") +
      "</div>" +
    "</div>"
  );
}

function renderServiceReviewCards(editable) {
  if (!state.sourceServicesDraft.length) {
    return '<div class="empty-state"><i class="fa-solid fa-file-circle-question"></i><div>No prefilled services have been surfaced yet.</div></div>';
  }

  return state.sourceServicesDraft.map(function(service) {
    return (
      '<div class="service-editor" style="cursor:' + (editable ? "grab" : "default") + ';">' +
        '<div class="service-top">' +
          '<div>' +
            '<div class="service-title">' + escapeHtml(service.personLabel || "Unnamed") + " -- " + escapeHtml(service.serviceLabel || "Service") + "</div>" +
            '<div class="service-meta">' +
              escapeHtml(service.category || "category n/a") +
              (service.notes ? " -- " + escapeHtml(service.notes) : "") +
              " -- " + escapeHtml(String(service.durationMin || 0)) + " mins" +
            "</div>" +
          "</div>" +
          '<div class="chip-row">' +
            '<span class="chip ' + escapeHtml(service.source || "missing") + '">' + escapeHtml(service.source || "source") + "</span>" +
            (service.assignedArtist ? '<span class="chip override">' + escapeHtml(service.assignedArtist) + "</span>" : "") +
          "</div>" +
        "</div>" +
      "</div>"
    );
  }).join("");
}

function renderEditableServiceCards() {
  if (!state.sourceServicesDraft.length) {
    return '<div class="empty-state"><i class="fa-solid fa-file-circle-question"></i><div>No source services were found to edit.</div></div>';
  }

  return state.sourceServicesDraft.map(function(service, index) {
    return (
      renderSourceDropSlot(index) +
      '<div class="service-editor" draggable="true" data-source-index="' + index + '" ondragstart="handleSourceDragStart(event)" ondragend="clearDragState()">' +
        '<div class="service-top">' +
          '<div>' +
            '<div class="service-title">' + escapeHtml(service.personLabel || "Person") + " -- " + escapeHtml(service.serviceLabel || "Service") + "</div>" +
            '<div class="service-meta">' +
              escapeHtml(service.category || "category n/a") +
              (service.notes ? " -- " + escapeHtml(service.notes) : "") +
              " -- " + escapeHtml(String(service.durationMin || 0)) + " mins" +
            "</div>" +
          "</div>" +
          '<div class="chip-row">' +
            (service.inspirationMatched ? '<span class="chip ok">Inspiration linked</span>' : '<span class="chip soft">Inspiration not linked</span>') +
            (service.folderMatched ? '<span class="chip ok">Folder matched</span>' : '') +
          '</div>' +
          '<div class="drag-handle"><i class="fa-solid fa-grip-vertical"></i></div>' +
        "</div>" +
        '<div class="service-fields">' +
          renderInlineInput("Person", "updateServiceField(" + index + ", 'personLabel', this.value)", service.personLabel || "") +
          renderInlineInput("Service Type", "updateServiceField(" + index + ", 'serviceLabel', this.value)", service.serviceLabel || "") +
          renderInlineSelect("Artist", buildArtistOptions(index), "updateServiceField(" + index + ", 'assignedArtist', this.value)") +
        "</div>" +
      "</div>"
    );
  }).join("") + renderSourceDropSlot(state.sourceServicesDraft.length);
}

function renderSourceDropSlot(index) {
  return (
    '<div class="drop-slot" data-drop-type="source" data-drop-index="' + index + '"' +
      ' ondragover="handleDropOver(event)" ondragleave="handleDropLeave(event)" ondrop="handleSourceDrop(event)"></div>'
  );
}

function renderTimelineLanes() {
  var structure = buildTimelineStructure();
  if (!structure.laneNames.length || !structure.rows.length) {
    return '<div class="empty-state"><i class="fa-solid fa-clock"></i><div>No timed rows are available yet.</div></div>';
  }

  var cols = ['92px'].concat(structure.laneNames.map(function() {
    return 'minmax(0, 1fr)';
  })).join(' ');
  var sheetMinWidth = 92 + (structure.laneNames.length * 240);

  var html =
    '<div class="timeline-sheet" style="min-width:' + sheetMinWidth + 'px;">' +
      '<div class="timeline-sheet-grid" style="grid-template-columns:' + cols + ';">' +
        '<div class="timeline-corner">Time</div>';

  structure.laneNames.forEach(function(name) {
    html += renderTimelineHeadCell(name, structure.grouped[name] || []);
  });

  structure.rows.forEach(function(row) {
    html += '<div class="timeline-time-cell">' + escapeHtml(inputTimeToDisplay(row.label)) + '</div>';
    structure.laneNames.forEach(function(name) {
      html += renderTimelineGridCell(name, row, structure.cellMap[name] || {});
    });
  });

  html += '</div></div>';
  return html;
}

function renderTimelineHeadCell(artistName, items) {
  var meta = buildArtistWindowMeta_(items);
  return (
    '<div class="timeline-head-cell">' +
      '<h4>' + escapeHtml(artistName) + '</h4>' +
      '<div class="timeline-head-meta">' +
        '<div>' + escapeHtml(String(items.length)) + ' services</div>' +
        '<div>Arrive ' + escapeHtml(meta.arrive || "TBC") + '</div>' +
        '<div>Pack up ' + escapeHtml(meta.pack || "TBC") + '</div>' +
      '</div>' +
    '</div>'
  );
}

function renderTimelineGridCell(artistName, row, laneMap) {
  var slot = laneMap[row.minutes];
  var classes = ["timeline-grid-cell"];
  if (slot && slot.type === "service") classes.push("occupied");
  if (slot && slot.type === "continuation") classes.push("continuation");

  var inner = "";
  if (slot && slot.type === "service") {
    var service = slot.service || {};
    inner =
      '<div class="timeline-service-block' + (service.isBride ? " bride" : "") + '" draggable="true" data-service-id="' + escapeHtml(service.id || "") + '"' +
        ' data-lane-artist="' + escapeHtml(artistName) + '" data-lane-index="' + Number(slot.index || 0) + '"' +
        ' ondragstart="handleTimelineDragStart(event)" ondragend="clearDragState()">' +
        '<div class="timeline-service-time">' + escapeHtml(service.start || "") + ' - ' + escapeHtml(service.end || "") + '</div>' +
        '<div class="timeline-service-title">' + escapeHtml(service.person || service.personLabel || "") + '</div>' +
        '<div class="timeline-service-meta">' + escapeHtml(service.service || service.serviceLabel || "") + ' -- ' + escapeHtml(String(service.duration || service.durationMin || 0)) + ' mins</div>' +
      '</div>';
  } else if (slot && (slot.type === "setup" || slot.type === "pack")) {
    inner =
      '<div class="timeline-service-block ' + escapeHtml(slot.type) + '">' +
        '<div class="timeline-service-time">' + escapeHtml(slot.start || "") + ' - ' + escapeHtml(slot.end || "") + '</div>' +
        '<div class="timeline-service-title">' + escapeHtml(slot.person || "") + '</div>' +
        '<div class="timeline-service-meta">' + escapeHtml(slot.label || "") + '</div>' +
      '</div>';
  } else if (slot && slot.type === "continuation") {
    inner = '<div class="timeline-continued">In Progress</div>';
  }

  return (
    '<div class="' + classes.join(" ") + '" data-drop-type="timeline" data-drop-artist="' + escapeHtml(artistName) + '"' +
      ' data-drop-index="' + Number(row.dropIndexByArtist[artistName] || 0) + '"' +
      ' ondragover="handleDropOver(event)" ondragleave="handleDropLeave(event)" ondrop="handleTimelineDrop(event)">' +
      inner +
    '</div>'
  );
}

function buildTimelineStructure() {
  var laneNames = getLaneNames();
  var grouped = {};
  var slotMinutes = 15;
  var timedServices = Array.isArray(state.workspace && state.workspace.services)
    ? state.workspace.services.slice()
    : [];

  laneNames.forEach(function(name) {
    grouped[name] = [];
  });

  timedServices.forEach(function(service) {
    var artist = String(service.artist || service.assignedArtist || "").trim() || "Unassigned";
    if (!grouped[artist]) grouped[artist] = [];
    grouped[artist].push(service);
  });

  var minStart = null;
  var maxEnd = null;
  laneNames.forEach(function(name) {
    grouped[name].sort(function(a, b) {
      return Number(parseDisplayTimeToMinutes(a.start || a.startTime || "") || 0) -
        Number(parseDisplayTimeToMinutes(b.start || b.startTime || "") || 0);
    });
    grouped[name].forEach(function(service) {
      var start = parseDisplayTimeToMinutes(service.start || service.startTime || "");
      var end = parseDisplayTimeToMinutes(service.end || service.endTime || "");
      if (start !== null && (minStart === null || start < minStart)) minStart = start;
      if (end !== null && (maxEnd === null || end > maxEnd)) maxEnd = end;
    });
  });

  if (minStart === null || maxEnd === null) {
    return {
      laneNames: laneNames,
      grouped: grouped,
      rows: [],
      cellMap: {}
    };
  }

  var startBound = Math.max(0, (Math.floor(minStart / slotMinutes) * slotMinutes) - slotMinutes);
  var endBound = (Math.ceil(maxEnd / slotMinutes) * slotMinutes) + (slotMinutes * 2);
  var rows = [];
  for (var minutes = startBound; minutes < endBound; minutes += slotMinutes) {
    var row = {
      minutes: minutes,
      label: String(Math.floor(minutes / 60)).padStart(2, "0") + ":" + String(minutes % 60).padStart(2, "0"),
      dropIndexByArtist: {}
    };
    laneNames.forEach(function(name) {
      row.dropIndexByArtist[name] = grouped[name].filter(function(service) {
        var start = parseDisplayTimeToMinutes(service.start || service.startTime || "");
        return start !== null && start < minutes;
      }).length;
    });
    rows.push(row);
  }

  var cellMap = {};
  laneNames.forEach(function(name) {
    cellMap[name] = {};
    var items = grouped[name] || [];
    items.forEach(function(service, index) {
      var start = parseDisplayTimeToMinutes(service.start || service.startTime || "");
      var end = parseDisplayTimeToMinutes(service.end || service.endTime || "");
      if (start === null || end === null) return;

      var startSlot = Math.floor(start / slotMinutes) * slotMinutes;
      var endSlot = Math.ceil(end / slotMinutes) * slotMinutes;

      cellMap[name][startSlot] = {
        type: "service",
        service: service,
        index: index
      };

      for (var cursor = startSlot + slotMinutes; cursor < endSlot; cursor += slotMinutes) {
        cellMap[name][cursor] = {
          type: "continuation",
          service: service,
          index: index
        };
      }
    });

    if (items.length) {
      var firstStart = parseDisplayTimeToMinutes(items[0].start || items[0].startTime || "");
      var lastEnd = parseDisplayTimeToMinutes(items[items.length - 1].end || items[items.length - 1].endTime || "");

      if (firstStart !== null) {
        var setupStart = Math.max(0, firstStart - slotMinutes);
        cellMap[name][setupStart] = {
          type: "setup",
          person: name + " arrives",
          label: "Set Up",
          start: formatMinutesAsDisplayTime_(setupStart),
          end: formatMinutesAsDisplayTime_(setupStart + slotMinutes)
        };
      }

      if (lastEnd !== null) {
        var packStart = lastEnd + slotMinutes;
        cellMap[name][packStart] = {
          type: "pack",
          person: name + " departs",
          label: "Pack Down",
          start: formatMinutesAsDisplayTime_(packStart),
          end: formatMinutesAsDisplayTime_(packStart + slotMinutes)
        };
      }
    }
  });

  return {
    laneNames: laneNames,
    grouped: grouped,
    rows: rows,
    cellMap: cellMap
  };
}

function buildArtistWindowMeta_(items) {
  var slotMinutes = 15;
  if (!items || !items.length) {
    return { arrive: "", pack: "" };
  }

  var starts = items
    .map(function(item) { return parseDisplayTimeToMinutes(item.start || item.startTime || ""); })
    .filter(function(item) { return item !== null; });
  var ends = items
    .map(function(item) { return parseDisplayTimeToMinutes(item.end || item.endTime || ""); })
    .filter(function(item) { return item !== null; });

  if (!starts.length || !ends.length) {
    return { arrive: "", pack: "" };
  }

  var firstStart = Math.min.apply(null, starts);
  var lastEnd = Math.max.apply(null, ends);

  return {
    arrive: formatMinutesAsDisplayTime_(Math.max(0, firstStart - slotMinutes)),
    pack: formatMinutesAsDisplayTime_(lastEnd + slotMinutes)
  };
}

function renderLeadArtistSelect(teamOptions) {
  var options = (teamOptions || []).filter(function(artist) {
    return !!artist.canLead;
  });
  var source = options.length ? options : (teamOptions || []);

  return (
    '<select id="leadArtistSelect" onchange="handleLeadArtistChange(this.value)">' +
      source.map(function(artist) {
        return '<option value="' + escapeHtml(artist.name) + '"' + (artist.name === state.leadArtist ? " selected" : "") + '>' + escapeHtml(artist.name) + "</option>";
      }).join("") +
    "</select>"
  );
}

function renderTeamCards(teamOptions) {
  if (!teamOptions.length) {
    return '<div class="empty-state" style="grid-column:1/-1;"><i class="fa-solid fa-users-slash"></i><div>No planning team data was returned.</div></div>';
  }

  return teamOptions.map(function(artist) {
    var checked = state.activeTeam.indexOf(artist.name) > -1;
    return (
      '<label class="team-card' + (checked ? " active" : "") + '">' +
        '<input type="checkbox" ' + (checked ? "checked " : "") + 'onchange="toggleArtist(\'' + escapeHtml(artist.name) + '\', this.checked)">' +
        '<div>' +
          '<div class="team-name">' + escapeHtml(artist.name) + "</div>" +
          '<div class="team-notes">' + escapeHtml(describeArtist(artist)) + "</div>" +
        "</div>" +
      "</label>"
    );
  }).join("");
}

function renderPdfField(label, fieldHtml) {
  return (
    '<div class="pdf-label">' + escapeHtml(label) + "</div>" +
    '<div class="pdf-value">' + fieldHtml + "</div>"
  );
}

function renderPdfWideField(label, fieldHtml) {
  return (
    '<div class="pdf-label">' + escapeHtml(label) + "</div>" +
    '<div class="pdf-value" style="grid-column: span 3;">' + fieldHtml + "</div>"
  );
}

function renderPdfEmptyField() {
  return '<div></div><div></div>';
}

function renderPartyUnit(label, value) {
  return (
    '<div class="party-unit">' +
      "<span>" + escapeHtml(label) + "</span>" +
      "<strong>" + escapeHtml(value) + "</strong>" +
    "</div>"
  );
}

function renderReadonlyField(label, value) {
  return (
    '<div class="field">' +
      "<label>" + escapeHtml(label) + "</label>" +
      '<input type="text" readonly value="' + escapeHtml(value || "") + '">' +
    "</div>"
  );
}

function buildPartyUnitSummary() {
  var summary = { bride: 0, bridesmaid: 0, mother: 0, guest: 0 };
  var seen = {};

  (state.sourceServicesDraft || []).forEach(function(service) {
    var person = String(service.personLabel || "").trim();
    if (!person) return;
    var key = person.toLowerCase();
    if (seen[key]) return;
    seen[key] = true;

    if (key.indexOf("bride") === 0 && key.indexOf("bridesmaid") !== 0) summary.bride += 1;
    else if (key.indexOf("bridesmaid") === 0) summary.bridesmaid += 1;
    else if (key.indexOf("mother") === 0) summary.mother += 1;
    else if (key.indexOf("guest") === 0) summary.guest += 1;
  });

  return summary;
}

function buildPersonBundleSummary() {
  var grouped = {};
  (state.sourceServicesDraft || []).forEach(function(service) {
    var person = String(service.personLabel || "Unnamed").trim();
    if (!grouped[person]) grouped[person] = [];
    grouped[person].push(String(service.serviceLabel || "Service").trim());
  });

  return Object.keys(grouped).map(function(person) {
    return { person: person, bundle: grouped[person].join(" + ") };
  });
}

function renderEditableField(label, id, value, type, helpText) {
  return (
    '<div class="field">' +
      "<label>" + escapeHtml(label) + "</label>" +
      '<input id="' + escapeHtml(id) + '" type="' + escapeHtml(type || "text") + '" value="' + escapeHtml(value || "") + '">' +
      '<small>' + escapeHtml(helpText || "") + "</small>" +
    "</div>"
  );
}

function renderEditableTextarea(label, id, value, helpText) {
  return (
    '<div class="field wide">' +
      "<label>" + escapeHtml(label) + "</label>" +
      '<textarea id="' + escapeHtml(id) + '" rows="3">' + escapeHtml(value || "") + "</textarea>" +
      '<small>' + escapeHtml(helpText || "") + "</small>" +
    "</div>"
  );
}

function renderInlineInput(label, onchange, value) {
  return (
    '<div class="field">' +
      "<label>" + escapeHtml(label) + "</label>" +
      '<input type="text" value="' + escapeHtml(value || "") + '" onchange="' + onchange + '">' +
    "</div>"
  );
}

function renderInlineSelect(label, optionsHtml, onchange) {
  return (
    '<div class="field">' +
      "<label>" + escapeHtml(label) + "</label>" +
      '<select onchange="' + onchange + '">' + optionsHtml + "</select>" +
    "</div>"
  );
}

function renderMiniStat(label, value) {
  return (
    '<div class="mini-stat">' +
      "<span>" + escapeHtml(label) + "</span>" +
      "<strong>" + escapeHtml(value) + "</strong>" +
    "</div>"
  );
}

function renderInfoRow(label, detail) {
  return (
    '<div class="info-row">' +
      "<strong>" + escapeHtml(label) + "</strong>" +
      "<div>" + detail + "</div>" +
    "</div>"
  );
}

function renderWarningRow(label, detail) {
  return (
    '<div class="warning-row">' +
      "<strong>" + escapeHtml(label) + "</strong>" +
      "<div>" + escapeHtml(detail || "Needs review") + "</div>" +
    "</div>"
  );
}

function renderSourceSummary(item, fallbackValue) {
  var source = String((item && item.source) || "missing").trim();
  var chipLabel = String((item && item.label) || source || "Unknown").trim();
  var detail = String((item && item.detail) || fallbackValue || "").trim();

  return (
    '<div class="chip-row" style="margin-bottom:6px;">' +
      '<span class="chip ' + escapeHtml(source) + '">' + escapeHtml(chipLabel) + "</span>" +
    "</div>" +
    '<div>' + escapeHtml(detail || "No detail available") + "</div>"
  );
}

function renderServicesSourceChips() {
  var sources = {};
  state.sourceServicesDraft.forEach(function(service) {
    var key = String(service.source || "missing").trim();
    sources[key] = (sources[key] || 0) + 1;
  });

  var keys = Object.keys(sources);
  if (!keys.length) return '<span class="chip missing">No service sources</span>';

  return keys.map(function(key) {
    return '<span class="chip ' + escapeHtml(key) + '">' + escapeHtml(key) + " -- " + escapeHtml(String(sources[key])) + "</span>";
  }).join("");
}

function renderReadinessHeadline(workspace) {
  if (workspace.services && workspace.services.length) return "Timeline ready";
  if (workspace.readyBy) return "Waiting on scheduling pass";
  return "Needs ready-by time";
}

function renderDebugItem_(label, value) {
  return (
    '<div class="debug-item">' +
      "<span>" + escapeHtml(label) + "</span>" +
      "<strong>" + escapeHtml(value || "\u2014") + "</strong>" +
    "</div>"
  );
}

function renderReadinessCopy(workspace) {
  if (workspace.services && workspace.services.length) {
    return "The service list is scheduled and ready for timeline review. You can now drag services between artists or publish.";
  }
  if (workspace.readyBy) {
    return "The booking has a finish time, but the planner still needs another pass after your latest edits.";
  }
  return "The service list is prefilled, but the planner cannot generate timed rows until the finish time is confirmed.";
}

function renderServiceMixText() {
  var items = state.sourceServicesDraft || [];
  var counts = {};
  items.forEach(function(service) {
    var key = String(service.serviceLabel || "Service").trim();
    counts[key] = (counts[key] || 0) + 1;
  });
  var keys = Object.keys(counts);
  if (!keys.length) return "No service rows yet";
  return keys.map(function(key) {
    return counts[key] + " " + key;
  }).join(" -- ");
}

function bindStageInputs() {
  var leadSelect = document.getElementById("leadArtistSelect");
  if (leadSelect) {
    leadSelect.value = state.leadArtist || leadSelect.value;
  }
}

function handleLeadArtistChange(value) {
  state.leadArtist = String(value || "").trim();
  if (state.leadArtist && state.activeTeam.indexOf(state.leadArtist) === -1) {
    state.activeTeam.unshift(state.leadArtist);
  }
  sanitizeSourceServicesDraftAssignments_();
  renderStage();
}

function toggleArtist(name, checked) {
  var safeName = String(name || "").trim();
  if (!safeName) return;

  if (checked) {
    if (state.activeTeam.indexOf(safeName) === -1) state.activeTeam.push(safeName);
  } else {
    state.activeTeam = state.activeTeam.filter(function(item) {
      return item !== safeName;
    });
    if (state.leadArtist === safeName) {
      state.leadArtist = state.activeTeam[0] || "";
    }
  }

  sanitizeSourceServicesDraftAssignments_();
  renderStage();
}

function updateServiceField(index, field, value) {
  var service = state.sourceServicesDraft[index];
  if (!service) return;

  if (field === "personLabel") {
    service.personLabel = String(value || "").trim();
    service.person = service.personLabel;
  } else if (field === "serviceLabel") {
    service.serviceLabel = String(value || "").trim();
    service.service = service.serviceLabel;
  } else if (field === "assignedArtist") {
    var nextArtist = String(value || "").trim();
    if (nextArtist && !canArtistHandleService_(nextArtist, service)) {
      showBanner(nextArtist + " is not marked for " + describeServiceSkill_(service) + ".", "warning");
      return;
    }
    service.assignedArtist = nextArtist;
    service.artist = service.assignedArtist;
  } else {
    service[field] = value;
  }

  sanitizeSourceServicesDraftAssignments_();
  renderStage();
}

function buildArtistOptions(index) {
  var service = state.sourceServicesDraft[index] || {};
  var selected = String(service.assignedArtist || service.artist || "").trim();
  var names = uniqueNames([].concat(state.activeTeam || [], [selected || ""]));
  var options = ['<option value="">Planner decides</option>'];
  names.forEach(function(name) {
    if (!name) return;
    if (name !== selected && !canArtistHandleService_(name, service)) return;
    options.push('<option value="' + escapeHtml(name) + '"' + (name === selected ? " selected" : "") + '>' + escapeHtml(name) + "</option>");
  });
  return options.join("");
}

function getArtistByName_(name) {
  var safeName = String(name || "").trim();
  return ((state.workspace && state.workspace.team) || []).find(function(artist) {
    return String(artist.name || "").trim() === safeName;
  }) || null;
}

function describeServiceSkill_(service) {
  var label = String(service.serviceLabel || service.service || "").toLowerCase();
  if (label.indexOf("make") > -1) return "makeup";
  if (label.indexOf("hair") > -1 || label.indexOf("wave") > -1 || label.indexOf("blow") > -1) return "hair";
  return "this service";
}

function canArtistHandleService_(artistName, service) {
  var safeArtist = String(artistName || "").trim();
  if (!safeArtist) return true;
  var artist = getArtistByName_(safeArtist);
  if (!artist) return true;
  var need = describeServiceSkill_(service);
  if (need === "makeup") return !!artist.canMakeup;
  if (need === "hair") return !!artist.canHair;
  return true;
}

function firstCompatibleArtistForService_(service) {
  var names = uniqueNames((state.activeTeam || []).concat(state.leadArtist ? [state.leadArtist] : []));
  for (var i = 0; i < names.length; i += 1) {
    if (canArtistHandleService_(names[i], service)) return names[i];
  }
  return "";
}

function sanitizeSourceServicesDraftAssignments_() {
  (state.sourceServicesDraft || []).forEach(function(service) {
    var assigned = String(service.assignedArtist || service.artist || "").trim();
    if (assigned && !canArtistHandleService_(assigned, service)) {
      var fallback = service.isBride && state.leadArtist && canArtistHandleService_(state.leadArtist, service)
        ? state.leadArtist
        : firstCompatibleArtistForService_(service);
      service.assignedArtist = fallback;
      service.artist = fallback;
    }
  });
}

function applyBookingDetails() {
  if (!state.currentBride) return;
  loadWorkspace(state.currentBride, buildCurrentOverrides());
}

function applyTeamAndServices() {
  if (!state.currentBride) return;
  loadWorkspace(state.currentBride, buildCurrentOverrides());
}

function buildCurrentOverrides(extra) {
  var bookingReadyByInput = document.getElementById("bookingReadyBy");
  var bookingLocationInput = document.getElementById("bookingLocation");
  var bookingServicesRequestedInput = document.getElementById("bookingServicesRequested");
  var bookingBridalPartyInput = document.getElementById("bookingBridalPartyCount");

  var overrides = {
    booking: {
      finishTime: bookingReadyByInput ? inputTimeToDisplay(bookingReadyByInput.value) : (state.workspace && state.workspace.readyBy) || "",
      location: bookingLocationInput ? bookingLocationInput.value : (state.workspace && state.workspace.location) || "",
      servicesRequested: bookingServicesRequestedInput ? bookingServicesRequestedInput.value : (state.workspace && state.workspace.servicesRequested) || "",
      bridalPartyCount: bookingBridalPartyInput ? bookingBridalPartyInput.value : (state.workspace && state.workspace.bridalPartyCount) || ""
    },
    services: normalisePayloadServices(state.sourceServicesDraft),
    leadArtist: state.leadArtist || "",
    overrideArtists: uniqueNames((state.activeTeam || []).concat(state.leadArtist ? [state.leadArtist] : []))
  };

  if (overrides.booking.finishTime) {
    overrides.finishTime = overrides.booking.finishTime;
  }

  return Object.assign(overrides, extra || {});
}

/* -- BRIDGE CALL #3: appPublishRunsheet(payload) --------------------- */
function publish() {
  if (!state.currentBride) return;

  // Lead artist not a real roster member (BUG-debbie-lyons-runsheet-publish-
  // b13-leadartist-2026-09-06, same root cause on the builder page --
  // state.leadArtist is never checked against the real team roster before
  // publish, so a stale/typo'd value (confirmed live on the builder: the
  // business name "Jessica Vegas", not an artist) survives silently until
  // the frozen engine's Sheets dropdown validation rejects it with no
  // useful context. Same narrow guard as jv-runsheet-builder.js's
  // publishConflictGate_ check 3, adapted to this file's simpler
  // (no-conflict-gate) publish() flow.
  var leadArtistCheck = String(state.leadArtist || '').trim();
  if (leadArtistCheck) {
    var rosterNamesCheck = uniqueNames(
      ((state.workspace && state.workspace.team) || []).map(function(t) { return String(t.name || '').trim(); }).filter(Boolean)
    );
    if (rosterNamesCheck.length && rosterNamesCheck.indexOf(leadArtistCheck) === -1) {
      showBanner('Lead artist "' + leadArtistCheck + '" is not a real team member (found: ' +
        rosterNamesCheck.join(', ') + '). Re-pick the lead artist before publishing.', 'error');
      return;
    }
  }

  setPublishDisabled(true);
  setPublishContent('<i class="fa-solid fa-spinner fa-spin"></i> Publishing...');

  var payload = buildCurrentOverrides();
  payload.brideName = state.currentBride;

  // Issue #10 S3a (2026-10-16): Planner now routes publish through CF
  // (bridge_runsheet_publishCf) by default, mirroring the builder's CF-first
  // path. Emergency rollback: set `window.PLANNER_CF_PUBLISH = false` (or '0')
  // and the planner reverts to the old GAS-sync `bridge_runsheet_publish` route.
  function plannerCfPublishEnabled_() {
    if (window.PLANNER_CF_PUBLISH === false || window.PLANNER_CF_PUBLISH === '0') return false;
    return true;
  }

  function plannerPublishViaGas_() {
    jvBridge.callAdmin('bridge_runsheet_publish', payload)
      .then(function(res) {
        setPublishDisabled(false);
        setPublishContent('<i class="fa-solid fa-paper-plane"></i> Publish');
        if (res.ok) {
          showBanner("Runsheet published successfully.", "success");
          if (res.data && res.data.url) {
            window.open(res.data.url, "_blank");
          }
          loadWorkspace(state.currentBride, buildCurrentOverrides());
        } else {
          showBanner(res.error || "Publish failed", "error");
        }
      })
      .catch(function(err) {
        setPublishDisabled(false);
        setPublishContent('<i class="fa-solid fa-paper-plane"></i> Publish');
        showBanner((err && err.message) || "Publish failed", "error");
      });
  }

  if (plannerCfPublishEnabled_()) {
    // Build CF payload shape (same minimal shape as the builder's
    // tryPublishViaCf_ — brideName/brideEmail/services/staffingDraft only).
    // The CF handler (DEPOLYMENT/jv-crm-mirror/runsheet-publish.mjs) auto-
    // builds the safe metafield subset. Calendar fields and metafields are
    // deliberately omitted — the CF handler skips calendar cleanly when
    // absent.
    var cfPayload = {
      brideName: state.currentBride,
      brideEmail: (state.workspace && state.workspace.email) || '',
      services: payload.services || [],
      staffingDraft: payload.staffingDraft || null,
      publishedBy: (window._jvAdminEmail || window._jvCustomerEmail || '') || null,
      tenantId: 'jessica-vegas'
    };

    jvBridge.callAdmin('bridge_runsheet_publishCf', cfPayload)
      .then(function(enqueueRes) {
        if (!(enqueueRes && enqueueRes.ok && enqueueRes.jobUuid)) {
          setPublishDisabled(false);
          setPublishContent('<i class="fa-solid fa-paper-plane"></i> Publish');
          showBanner((enqueueRes && enqueueRes.error) || 'CF publish rejected the request (no jobUuid returned).', 'error');
          return;
        }
        setPublishContent('<i class="fa-solid fa-spinner fa-spin"></i> Publishing on CF...');
        if (!window.jvJobPoll || typeof window.jvJobPoll.pollJobStatus !== 'function') {
          setPublishDisabled(false);
          setPublishContent('<i class="fa-solid fa-paper-plane"></i> Publish');
          showBanner('CF publish started but the client poller (jv-job-poll.js) is not loaded. Reload the page and try again.', 'error');
          return;
        }
        window.jvJobPoll.pollJobStatus(enqueueRes.jobUuid, {
          maxMs: 10 * 60 * 1000,
          pollIntervalMs: 3000,
          onProgress: function (s) {
            if (s && s.status === 'running') {
              setPublishContent('<i class="fa-solid fa-spinner fa-spin"></i> Publishing on CF (running)...');
            }
          }
        }).then(function(finalStatus) {
          setPublishDisabled(false);
          setPublishContent('<i class="fa-solid fa-paper-plane"></i> Publish');
          if (finalStatus && finalStatus.status === 'done') {
            showBanner('Runsheet published.', 'success');
            loadWorkspace(state.currentBride, buildCurrentOverrides());
          } else if (finalStatus && finalStatus.status === 'failed') {
            showBanner('CF publish failed: ' + (finalStatus.error || 'unknown error'), 'error');
          } else {
            showBanner((finalStatus && finalStatus.error) || 'CF publish did not finish in the allowed time. The job may still be running — refresh in a minute to check.', 'error');
          }
        }).catch(function(err) {
          setPublishDisabled(false);
          setPublishContent('<i class="fa-solid fa-paper-plane"></i> Publish');
          showBanner('CF publish poll error: ' + ((err && err.message) || err), 'error');
        });
      })
      .catch(function(err) {
        setPublishDisabled(false);
        setPublishContent('<i class="fa-solid fa-paper-plane"></i> Publish');
        showBanner('CF publish could not start: ' + ((err && err.message) || err) + '. Set PLANNER_CF_PUBLISH=0 to use the GAS path.', 'error');
      });
    return;
  }

  plannerPublishViaGas_();
  return;
  // Legacy path (never reached — kept for reference / historical catch block below).
  jvBridge.callAdmin('bridge_runsheet_publish', payload)
    .then(function(res) {
      setPublishDisabled(false);
      setPublishContent('<i class="fa-solid fa-paper-plane"></i> Publish');
      if (res.ok) {
        showBanner("Runsheet published successfully.", "success");
        if (res.data && res.data.url) {
          window.open(res.data.url, "_blank");
        }
        loadWorkspace(state.currentBride, buildCurrentOverrides());
      } else {
        showBanner(res.error || "Publish failed", "error");
      }
    })
    .catch(function(err) {
      setPublishDisabled(false);
      setPublishContent('<i class="fa-solid fa-paper-plane"></i> Publish');
      showBanner(getErrorMessage(err), "error");
    });
}

/* -- BRIDGE CALL #4: appRepairRunsheetSources(brideName) ------------- */
function refreshSourceData() {
  if (!state.currentBride) return;
  setRepairDisabled(true);
  setRepairContent('<i class="fa-solid fa-spinner fa-spin"></i> Repairing...');
  showBanner("Checking invoices, Drive links, and cached runsheet data for this bride...", "success");

  jvBridge.callAdmin('bridge_runsheet_repairSources', { brideName: state.currentBride })
    .then(function(res) {
      setRepairDisabled(false);
      setRepairContent('<i class="fa-solid fa-screwdriver-wrench"></i> Repair');
      if (res.ok) {
        loadWorkspace(state.currentBride, buildCurrentOverrides());
      } else {
        showBanner(res.error || "Repair failed", "error");
      }
    })
    .catch(function(err) {
      setRepairDisabled(false);
      setRepairContent('<i class="fa-solid fa-screwdriver-wrench"></i> Repair');
      showBanner(getErrorMessage(err), "error");
    });
}

/* -- Drag and Drop --------------------------------------------------- */
function handleSourceDragStart(event) {
  state.dragServiceId = "";
  state.dragSource = "source";
  var index = Number(event.currentTarget.getAttribute("data-source-index"));
  var service = state.sourceServicesDraft[index];
  if (!service) return;
  state.dragServiceId = service.id;
  event.currentTarget.classList.add("dragging");
}

function handleTimelineDragStart(event) {
  state.dragSource = "timeline";
  state.dragServiceId = String(event.currentTarget.getAttribute("data-service-id") || "");
  event.currentTarget.classList.add("dragging");
}

function clearDragState() {
  state.dragServiceId = "";
  state.dragSource = "";
  Array.from(document.querySelectorAll(".jv-runsheet-planner .dragging")).forEach(function(node) {
    node.classList.remove("dragging");
  });
  Array.from(document.querySelectorAll(".jv-runsheet-planner .drop-slot.active")).forEach(function(node) {
    node.classList.remove("active");
  });
  Array.from(document.querySelectorAll(".jv-runsheet-planner .timeline-grid-cell.drop-active")).forEach(function(node) {
    node.classList.remove("drop-active");
  });
}

function handleDropOver(event) {
  event.preventDefault();
  event.currentTarget.classList.add("active");
  if (event.currentTarget.classList.contains("timeline-grid-cell")) {
    event.currentTarget.classList.add("drop-active");
  }
}

function handleDropLeave(event) {
  event.currentTarget.classList.remove("active");
  event.currentTarget.classList.remove("drop-active");
}

function handleSourceDrop(event) {
  event.preventDefault();
  event.currentTarget.classList.remove("active");
  if (state.dragSource !== "source" || !state.dragServiceId) return;

  var targetIndex = Number(event.currentTarget.getAttribute("data-drop-index"));
  moveSourceService(state.dragServiceId, targetIndex);
  clearDragState();
  renderStage();
}

function handleTimelineDrop(event) {
  event.preventDefault();
  event.currentTarget.classList.remove("active");
  event.currentTarget.classList.remove("drop-active");
  if (state.dragSource !== "timeline" || !state.dragServiceId) return;

  var targetArtist = String(event.currentTarget.getAttribute("data-drop-artist") || "").trim();
  var targetIndex = Number(event.currentTarget.getAttribute("data-drop-index"));
  applyTimelineMove(state.dragServiceId, targetArtist, targetIndex);
  clearDragState();
}

function moveSourceService(serviceId, targetIndex) {
  var current = state.sourceServicesDraft.slice();
  var fromIndex = current.findIndex(function(item) { return item.id === serviceId; });
  if (fromIndex === -1) return;

  var moved = current.splice(fromIndex, 1)[0];
  var safeTarget = Math.max(0, Math.min(targetIndex, current.length));
  current.splice(safeTarget, 0, moved);
  current.forEach(function(item, index) {
    item.order = index + 1;
  });
  state.sourceServicesDraft = current;
}

function applyTimelineMove(serviceId, targetArtist, targetIndex) {
  var laneNames = getLaneNames();
  var grouped = {};
  var laneByService = {};

  laneNames.forEach(function(name) {
    grouped[name] = [];
  });

  (state.workspace.services || []).forEach(function(service) {
    var artist = String(service.artist || service.assignedArtist || "").trim() || "Unassigned";
    if (!grouped[artist]) grouped[artist] = [];
    grouped[artist].push(service);
    laneByService[service.id] = artist;
  });

  var sourceLane = laneByService[serviceId];
  if (!sourceLane) return;

  var currentLane = grouped[sourceLane] || [];
  var serviceIndex = currentLane.findIndex(function(item) { return item.id === serviceId; });
  if (serviceIndex === -1) return;

  var moved = currentLane.splice(serviceIndex, 1)[0];
  if (targetArtist && !canArtistHandleService_(targetArtist, moved)) {
    showBanner(targetArtist + " is not marked for " + describeServiceSkill_(moved) + ".", "warning");
    return;
  }
  if (!grouped[targetArtist]) grouped[targetArtist] = [];
  var safeTarget = Math.max(0, Math.min(targetIndex, grouped[targetArtist].length));
  grouped[targetArtist].splice(safeTarget, 0, moved);

  var orderedIds = [];
  var assignedById = {};
  laneNames.forEach(function(name) {
    (grouped[name] || []).forEach(function(item) {
      orderedIds.push(item.id);
      assignedById[item.id] = name;
    });
  });

  var byId = {};
  state.sourceServicesDraft.forEach(function(item) {
    byId[item.id] = Object.assign({}, item);
  });

  var next = [];
  orderedIds.forEach(function(id, index) {
    if (!byId[id]) return;
    byId[id].assignedArtist = assignedById[id] || byId[id].assignedArtist || "";
    byId[id].artist = byId[id].assignedArtist;
    byId[id].order = index + 1;
    next.push(byId[id]);
    delete byId[id];
  });

  Object.keys(byId).forEach(function(id) {
    next.push(byId[id]);
  });

  next.forEach(function(item, index) {
    item.order = index + 1;
  });

  state.sourceServicesDraft = next;
  syncWorkspaceTimelineFromSourceDraft_();
  state.timelineDirty = true;
  showBanner("Timeline updated locally. Click Rebuild Preview when you want timing recalculated.", "warning");
  renderStage();
}

function getLaneNames() {
  var names = uniqueNames(
    (state.activeTeam || []).concat(
      ((state.workspace && state.workspace.services) || []).map(function(item) {
        return item.artist || item.assignedArtist || "";
      })
    )
  );
  return names.length ? names : ["Unassigned"];
}

function syncWorkspaceTimelineFromSourceDraft_() {
  if (!state.workspace) return;

  var selectedArtists = uniqueNames(
    (state.activeTeam || [])
      .concat(state.leadArtist ? [state.leadArtist] : [])
      .concat((state.sourceServicesDraft || []).map(function(service) {
        return service.assignedArtist || service.artist || "";
      }))
  );
  var safeArtists = selectedArtists.length ? selectedArtists : ["Unassigned"];
  var readyByLabel = String(state.workspace.readyBy || "").trim();
  var parsedReadyBy = parseDisplayTimeToMinutes(readyByLabel);
  var readyByMinutes = parsedReadyBy !== null ? parsedReadyBy : (15 * 60);
  var slotMinutes = 15;
  var ordered = (state.sourceServicesDraft || []).slice().sort(function(a, b) {
    return Number(a.order || 0) - Number(b.order || 0);
  });
  var orderedForSchedule = buildSchedulingOrder_(ordered);
  var totalServiceMinutes = ordered.reduce(function(sum, service) {
    return sum + Number(service.durationMin || service.duration || 0);
  }, 0);

  var artistState = {};
  var personState = {};
  safeArtists.forEach(function(name) {
    artistState[name] = readyByMinutes;
  });

  var scheduledInReverse = orderedForSchedule.slice().reverse().map(function(service, reverseIndex) {
    var sourceIndex = orderedForSchedule.length - reverseIndex;
    var id = String(service.id || ("src_" + sourceIndex));
    var assignedArtist = String(service.assignedArtist || service.artist || safeArtists[0] || "Unassigned").trim() || "Unassigned";
    var person = String(service.personLabel || service.person || "").trim();
    var serviceLabel = String(service.serviceLabel || service.service || "").trim();
    var rawDuration = Number(service.durationMin || service.duration || 0);
    var durationMin = Math.max(slotMinutes, Math.ceil(rawDuration / slotMinutes) * slotMinutes);
    var personKey = person.toLowerCase();

    if (artistState[assignedArtist] === undefined) {
      artistState[assignedArtist] = readyByMinutes;
    }

    var latestArtistEnd = Number(artistState[assignedArtist] || readyByMinutes);
    var latestPersonEnd = personKey && personState[personKey] !== undefined
      ? Number(personState[personKey])
      : readyByMinutes;
    var endMinutes = Math.min(latestArtistEnd, latestPersonEnd);
    var startMinutes = Math.max(0, endMinutes - durationMin);

    artistState[assignedArtist] = startMinutes;
    if (personKey) {
      personState[personKey] = startMinutes;
    }

    return {
      id: id,
      order: Number(service.order || sourceIndex),
      person: person,
      personLabel: person,
      service: serviceLabel,
      serviceLabel: serviceLabel,
      category: String(service.category || "").trim(),
      duration: durationMin,
      durationMin: durationMin,
      artist: assignedArtist,
      assignedArtist: assignedArtist,
      start: formatMinutesAsDisplayTime_(startMinutes),
      startTime: formatMinutesAsDisplayTime_(startMinutes),
      end: formatMinutesAsDisplayTime_(endMinutes),
      endTime: formatMinutesAsDisplayTime_(endMinutes),
      startMin: startMinutes,
      endMin: endMinutes,
      isBride: !!service.isBride,
      notes: String(service.notes || "").trim()
    };
  });

  var nextServices = scheduledInReverse.reverse().sort(function(a, b) {
    return Number(a.order || 0) - Number(b.order || 0);
  });

  state.workspace.services = nextServices;
  state.workspace.selectedArtists = safeArtists;
  state.workspace.leadArtist = state.leadArtist || state.workspace.leadArtist || "";
  state.workspace.totalServiceMinutes = totalServiceMinutes;
  state.workspace.draftStartTime = nextServices.length
    ? formatMinutesAsDisplayTime_(Math.max(0, Math.min.apply(null, nextServices.map(function(service) {
        return Number(service.startMin || 0);
      })) - slotMinutes))
    : formatMinutesAsDisplayTime_(Math.max(0, readyByMinutes - slotMinutes));
}

function inferLocalTimelineStartMinutes_() {
  var existingStarts = ((state.workspace && state.workspace.services) || [])
    .map(function(service) {
      return parseDisplayTimeToMinutes(service.start || service.startTime || "");
    })
    .filter(function(value) {
      return value !== null;
    });

  if (existingStarts.length) {
    return Math.min.apply(null, existingStarts);
  }

  return 12 * 60;
}

function buildSchedulingOrder_(services) {
  var regular = [];
  var brideHair = null;
  var brideMakeup = null;

  (services || []).forEach(function(service) {
    var isBride = !!service.isBride || String(service.personLabel || service.person || "").trim().toLowerCase() === "bride";
    var label = String(service.serviceLabel || service.service || "").toLowerCase();
    if (isBride && label.indexOf("hair") > -1) {
      brideHair = service;
      return;
    }
    if (isBride && label.indexOf("make") > -1) {
      brideMakeup = service;
      return;
    }
    regular.push(service);
  });

  if (brideHair) regular.push(brideHair);
  if (brideMakeup) regular.push(brideMakeup);
  return regular;
}

function normaliseEditableServices(services) {
  return (services || []).map(function(service, index) {
    var id = String(service.id || service.itemId || ("src_" + (index + 1)));
    var person = String(service.personLabel || service.person || "").trim();
    var serviceLabel = String(service.serviceLabel || service.service || "").trim();
    var assignedArtist = String(service.assignedArtist || service.artist || "").trim();
    return {
      id: id,
      order: Number(service.order || (index + 1)),
      person: person,
      personLabel: person,
      service: serviceLabel,
      serviceLabel: serviceLabel,
      category: String(service.category || "").trim(),
      durationMin: Number(service.durationMin || service.duration || 0),
      assignedArtist: assignedArtist,
      artist: assignedArtist,
      isBride: !!service.isBride,
      notes: String(service.notes || "").trim(),
      source: String(service.source || "").trim()
    };
  }).sort(function(a, b) {
    return Number(a.order || 0) - Number(b.order || 0);
  });
}

function normalisePayloadServices(services) {
  return (services || []).map(function(service, index) {
    return {
      id: String(service.id || ("src_" + (index + 1))),
      order: Number(service.order || (index + 1)),
      person: String(service.personLabel || service.person || "").trim(),
      personLabel: String(service.personLabel || service.person || "").trim(),
      service: String(service.serviceLabel || service.service || "").trim(),
      serviceLabel: String(service.serviceLabel || service.service || "").trim(),
      category: String(service.category || "").trim(),
      durationMin: Number(service.durationMin || 0),
      assignedArtist: String(service.assignedArtist || service.artist || "").trim(),
      artist: String(service.assignedArtist || service.artist || "").trim(),
      isBride: !!service.isBride,
      notes: String(service.notes || "").trim(),
      source: String(service.source || "").trim()
    };
  });
}

function buildMetaLine(workspace) {
  var bits = [];
  if (workspace.weddingDate) bits.push(workspace.weddingDate);
  if (workspace.location) bits.push(workspace.location);
  if (workspace.readyBy) bits.push("ready by " + workspace.readyBy);
  bits.push(String(state.sourceServicesDraft.length || 0) + " source services");
  if (workspace.services && workspace.services.length) {
    bits.push(String(workspace.services.length) + " timed rows");
  }
  return bits.join(" -- ");
}

/* -- Time Utilities -------------------------------------------------- */
function displayTimeToInput(value) {
  var mins = parseDisplayTimeToMinutes(value);
  if (mins === null) return "";
  var hours = Math.floor(mins / 60);
  var minutes = mins % 60;
  return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0");
}

function inputTimeToDisplay(value) {
  var raw = String(value || "").trim();
  if (!raw || raw.indexOf(":") === -1) return "";
  var parts = raw.split(":").map(Number);
  if (parts.length !== 2 || isNaN(parts[0]) || isNaN(parts[1])) return "";
  var hours = parts[0];
  var minutes = parts[1];
  var suffix = hours >= 12 ? "PM" : "AM";
  if (hours === 0) hours = 12;
  if (hours > 12) hours -= 12;
  return hours + ":" + String(minutes).padStart(2, "0") + " " + suffix;
}

function formatMinutesAsDisplayTime_(value) {
  if (value == null || isNaN(value)) return "";
  var safe = Math.max(0, Number(value));
  return inputTimeToDisplay(
    String(Math.floor(safe / 60)).padStart(2, "0") + ":" + String(safe % 60).padStart(2, "0")
  );
}

function parseDisplayTimeToMinutes(value) {
  var match = String(value || "").trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!match) return null;

  var hours = Number(match[1]);
  var minutes = Number(match[2]);
  var suffix = match[3].toUpperCase();

  if (suffix === "AM" && hours === 12) hours = 0;
  if (suffix === "PM" && hours !== 12) hours += 12;

  return (hours * 60) + minutes;
}

function findEarliestStart(services) {
  var starts = (services || [])
    .map(function(item) { return parseDisplayTimeToMinutes(item.start || item.startTime || ""); })
    .filter(function(item) { return item !== null; });

  if (!starts.length) return "";
  var min = Math.min.apply(null, starts);
  return inputTimeToDisplay(
    String(Math.floor(min / 60)).padStart(2, "0") + ":" + String(min % 60).padStart(2, "0")
  );
}

function findLatestFinish(services) {
  var ends = (services || [])
    .map(function(item) { return parseDisplayTimeToMinutes(item.end || item.endTime || ""); })
    .filter(function(item) { return item !== null; });

  if (!ends.length) return "";
  var max = Math.max.apply(null, ends);
  return inputTimeToDisplay(
    String(Math.floor(max / 60)).padStart(2, "0") + ":" + String(max % 60).padStart(2, "0")
  );
}

/* -- Utility --------------------------------------------------------- */
function uniqueNames(values) {
  var out = [];
  (values || []).forEach(function(value) {
    var safe = String(value || "").trim();
    if (safe && out.indexOf(safe) === -1) out.push(safe);
  });
  return out;
}

function buildHydrateDebug_(workspace) {
  var safe = workspace || {};
  return {
    state: workspace ? "hydrated" : "empty",
    brideName: String(safe.brideName || state.currentBride || "").trim(),
    weddingDate: String(safe.weddingDate || "").trim(),
    location: String(safe.location || "").trim(),
    readyBy: String(safe.readyBy || "").trim(),
    sourceServices: Array.isArray(safe.sourceServices) ? safe.sourceServices.length : 0,
    timedServices: Array.isArray(safe.services) ? safe.services.length : 0,
    recommendedArtistCount: Number(safe.recommendedArtistCount || 0),
    selectedArtists: Array.isArray(safe.selectedArtists) ? safe.selectedArtists.join(", ") : "",
    leadArtist: String(safe.leadArtist || "").trim(),
    phone: String(safe.phone || "").trim(),
    message: workspace ? "Workspace received by browser" : "No workspace payload received"
  };
}

function describeArtist(artist) {
  var bits = [];
  if (artist.canLead) bits.push("Lead");
  if (artist.canHair && artist.canMakeup) bits.push("Hair + Makeup");
  else if (artist.canHair) bits.push("Hair");
  else if (artist.canMakeup) bits.push("Makeup");
  if (artist.region) bits.push(artist.region);
  return bits.join(" -- ") || "Available artist";
}

function getProvenance(workspace, key) {
  return (workspace && workspace.provenance && workspace.provenance[key]) || {};
}

function showBanner(message, type) {
  var banner = document.getElementById("statusBanner");
  banner.className = "status-banner " + (type || "success");
  banner.innerHTML =
    '<i class="fa-solid ' + (
      type === "error"
        ? 'fa-triangle-exclamation'
        : type === "warning"
          ? 'fa-circle-exclamation'
          : 'fa-circle-check'
    ) + '"></i>' +
    "<span>" + escapeHtml(message) + "</span>";
}

function hideBanner() {
  var banner = document.getElementById("statusBanner");
  banner.className = "status-banner";
  banner.innerHTML = "";
}

function getErrorMessage(err) {
  if (!err) return "Unknown error";
  if (typeof err === "string") return err;
  return err.message || String(err);
}

function escapeHtml(value) {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/* =====================================================================
   TOUCH DRAG-DROP SYSTEM
   Implements long-press -> drag -> drop for touch devices.
   ===================================================================== */

var TOUCH_HOLD_MS = 350;
var TOUCH_MOVE_THRESHOLD = 8;

function initTouchDragDrop_() {
  if (!IS_TOUCH_DEVICE) return;

  document.addEventListener("touchstart", onTouchStart_, { passive: false });
  document.addEventListener("touchmove", onTouchMove_, { passive: false });
  document.addEventListener("touchend", onTouchEnd_, { passive: false });
  document.addEventListener("touchcancel", onTouchCancel_, { passive: false });
}

function findDraggableAncestor_(el) {
  var node = el;
  while (node && node !== document.body) {
    if (node.getAttribute && node.getAttribute("draggable") === "true") return node;
    node = node.parentElement;
  }
  return null;
}

function onTouchStart_(e) {
  var draggable = findDraggableAncestor_(e.target);
  if (!draggable) return;

  var touch = e.touches[0];
  touchDrag.startX = touch.clientX;
  touchDrag.startY = touch.clientY;
  touchDrag.element = draggable;

  clearTimeout(touchDrag.holdTimer);
  touchDrag.holdTimer = setTimeout(function() {
    beginTouchDrag_(draggable, touch);
  }, TOUCH_HOLD_MS);
}

function beginTouchDrag_(el, touch) {
  touchDrag.active = true;
  el.classList.add("touch-held");

  if (el.hasAttribute("data-source-index")) {
    touchDrag.source = "source";
    var idx = Number(el.getAttribute("data-source-index"));
    var svc = state.sourceServicesDraft[idx];
    touchDrag.serviceId = svc ? svc.id : "";
    state.dragSource = "source";
    state.dragServiceId = touchDrag.serviceId;
  } else if (el.hasAttribute("data-service-id")) {
    touchDrag.source = "timeline";
    touchDrag.serviceId = String(el.getAttribute("data-service-id") || "");
    state.dragSource = "timeline";
    state.dragServiceId = touchDrag.serviceId;
  }

  createTouchGhost_(el, touch);

  if (navigator.vibrate) navigator.vibrate(20);
}

function createTouchGhost_(el, touch) {
  removeTouchGhost_();
  var ghost = document.createElement("div");
  ghost.className = "touch-drag-ghost";

  var titleEl = el.querySelector(".service-title, .timeline-service-title");
  ghost.textContent = titleEl ? titleEl.textContent.substring(0, 40) : "Moving...";

  ghost.style.left = touch.clientX + "px";
  ghost.style.top = touch.clientY + "px";
  document.body.appendChild(ghost);
  touchDrag.ghost = ghost;
}

function removeTouchGhost_() {
  if (touchDrag.ghost && touchDrag.ghost.parentNode) {
    touchDrag.ghost.parentNode.removeChild(touchDrag.ghost);
  }
  touchDrag.ghost = null;
}

function onTouchMove_(e) {
  if (!touchDrag.element) return;

  var touch = e.touches[0];
  var dx = Math.abs(touch.clientX - touchDrag.startX);
  var dy = Math.abs(touch.clientY - touchDrag.startY);

  if (!touchDrag.active && (dx > TOUCH_MOVE_THRESHOLD || dy > TOUCH_MOVE_THRESHOLD)) {
    clearTimeout(touchDrag.holdTimer);
    resetTouchDrag_();
    return;
  }

  if (!touchDrag.active) return;

  e.preventDefault();

  if (touchDrag.ghost) {
    touchDrag.ghost.style.left = touch.clientX + "px";
    touchDrag.ghost.style.top = touch.clientY + "px";
  }

  var elemBelow = document.elementFromPoint(touch.clientX, touch.clientY);
  updateTouchDropTarget_(elemBelow);
}

function updateTouchDropTarget_(elem) {
  var dropTarget = findDropTarget_(elem);

  if (touchDrag.currentDropTarget && touchDrag.currentDropTarget !== dropTarget) {
    touchDrag.currentDropTarget.classList.remove("touch-over");
  }

  if (dropTarget) {
    dropTarget.classList.add("touch-over");
  }

  touchDrag.currentDropTarget = dropTarget;
}

function findDropTarget_(el) {
  var node = el;
  while (node && node !== document.body) {
    if (node.hasAttribute && node.hasAttribute("data-drop-type")) return node;
    node = node.parentElement;
  }
  return null;
}

function onTouchEnd_(e) {
  clearTimeout(touchDrag.holdTimer);

  if (!touchDrag.active) {
    resetTouchDrag_();
    return;
  }

  var target = touchDrag.currentDropTarget;
  if (target) {
    target.classList.remove("touch-over");
    var dropType = target.getAttribute("data-drop-type");

    if (dropType === "source" && touchDrag.source === "source") {
      var targetIndex = Number(target.getAttribute("data-drop-index"));
      moveSourceService(state.dragServiceId, targetIndex);
      clearDragState();
      renderStage();
    } else if (dropType === "timeline" && touchDrag.source === "timeline") {
      var targetArtist = String(target.getAttribute("data-drop-artist") || "").trim();
      var targetIdx = Number(target.getAttribute("data-drop-index"));
      applyTimelineMove(state.dragServiceId, targetArtist, targetIdx);
      clearDragState();
    }
  }

  resetTouchDrag_();
}

function onTouchCancel_() {
  clearTimeout(touchDrag.holdTimer);
  resetTouchDrag_();
  clearDragState();
}

function resetTouchDrag_() {
  if (touchDrag.element) {
    touchDrag.element.classList.remove("touch-held");
  }
  if (touchDrag.currentDropTarget) {
    touchDrag.currentDropTarget.classList.remove("touch-over");
  }
  removeTouchGhost_();
  touchDrag.active = false;
  touchDrag.element = null;
  touchDrag.serviceId = "";
  touchDrag.source = "";
  touchDrag.currentDropTarget = null;
}

/* Initialise touch drag-drop on load */
initTouchDragDrop_();
